export const THEME_PRIMARY = 'primary';
export const THEME_SECONDARY = 'secondary';
export const THEME_TERTIARY = 'tertiary';
export const THEME_QUADTERNARY = 'quadternary';
